/* @flow */

export const SET_POST_BRAINDATE_FEEDBACK_REQUEST =
  'SET_POST_BRAINDATE_FEEDBACK_REQUEST';
export const SET_POST_BRAINDATE_FEEDBACK_FAILURE =
  'SET_POST_BRAINDATE_FEEDBACK_FAILURE';
export const SET_POST_BRAINDATE_FEEDBACK_SUCCESS =
  'SET_POST_BRAINDATE_FEEDBACK_SUCCESS';
